import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import ReferralHash from "../../../common/referral-hash";

import menu from "../../../assets/graphics/icons/menu.svg";
import cross from "../../../assets/graphics/icons/cross.svg";

import "features/application/navigation/view.scss";

const NavigationView = ({
  currentStep,
  memberships,
  userData,
  navigationReference,
  toggleNavigationVisibility,
  disableLink,
}) => (
  <nav className="form__navigation">
    <h2 className="navigation__headline">
      {userData &&
      userData.plan_id &&
      memberships &&
      memberships.find((membership) => membership.id === userData.plan_id)
        ? memberships.find((membership) => membership.id === userData.plan_id)
            .name
        : "Application form"}
    </h2>
    <img
      className="navigation__button"
      src={menu}
      alt="menu"
      onClick={toggleNavigationVisibility}
    />
    <ol
      className="navigation__list"
      style={{ display: "none" }}
      ref={navigationReference}
    >
      <img
        className="navigation__cross"
        src={cross}
        alt="cross"
        onClick={toggleNavigationVisibility}
      />
      <li
        className={`navigation__item${
          currentStep === "reasons-to-join" ? "--active" : ""
        }`}
      >
        <Link
          to={
            "/application/reasons-to-join" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          }
          data-step="1"
          onClick={disableLink}
        >
          Reasons to Join
        </Link>
      </li>
      <li
        className={`navigation__item${
          currentStep === "details" ? "--active" : ""
        }`}
      >
        <Link
          to={
            "/application/details" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          }
          data-step="2"
          onClick={disableLink}
        >
          Details
        </Link>
      </li>
      <li
        className={`navigation__item${
          currentStep === "interests" ? "--active" : ""
        }`}
      >
        <Link
          to={
            "/application/interests" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          }
          data-step="3"
          onClick={disableLink}
        >
          Interests
        </Link>
      </li>
      <li
        className={`navigation__item${
          currentStep === "about" ? "--active" : ""
        }`}
      >
        <Link
          to={
            "/application/about" +
            (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
          }
          data-step="4"
          onClick={disableLink}
        >
          About
        </Link>
      </li>
      {userData && !userData.is_referred && userData.use_payment && (
        <li
          className={`navigation__item${
            currentStep === "memberships" ? "--active" : ""
          }`}
        >
          <Link
            to={
              "/application/memberships" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            }
            data-step="5"
            onClick={disableLink}
          >
            Membership
          </Link>
        </li>
      )}
      {userData &&
        !userData.is_referred &&
        userData.use_payment &&
        (memberships &&
        memberships.find((membership) => membership.id === userData.plan_id)
          ? !memberships.find(
              (membership) => membership.id === userData.plan_id
            ).is_free
          : true) && (
          <li
            className={`navigation__item${
              currentStep === "payment" ? "--active" : ""
            }`}
          >
            <Link
              to={
                "/application/payment" +
                (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
              }
              data-step="6"
              onClick={disableLink}
            >
              Card
            </Link>
          </li>
        )}
      {(!userData.is_verified_email || !userData.is_terms_accepted) && (
        <li
          className={`navigation__item${
            currentStep === "email-confirmation" ? "--active" : ""
          }`}
        >
          <Link
            to={
              "/application/email-confirmation" +
              (ReferralHash.hash ? "?referral_hash=" + ReferralHash.hash : "")
            }
            data-step="7"
            onClick={disableLink}
          >
            E-mail confirmation
          </Link>
        </li>
      )}
    </ol>
  </nav>
);

NavigationView.propTypes = {
  currentStep: PropTypes.string,
  memberships: PropTypes.array,
  userData: PropTypes.object,
  navigationReference: PropTypes.object,
  toggleNavigationVisibility: PropTypes.func,
  disableLink: PropTypes.func,
};

export default NavigationView;
